import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./translationEN.json";
// i18next configuration
i18n.use(LanguageDetector) // Using LanguageDetector to automatically detect language
	.use(initReactI18next) // Binding with React
	.init({
		resources: {
			en: {
				translation: translationEN,
			},
		},
		fallbackLng: "en", // Default language
		interpolation: {
			escapeValue: false, // React already protects from XSS
		},
	});

export default i18n;
